import { axiosInstance } from "@/plugins/axios";
import { Api } from "@/common/api/Api";
import MeterRouter from "@/context/meter/router/MeterRouter";
import { AxiosInstance } from "axios";

export class MeterApi extends Api {
  constructor(axios: AxiosInstance) {
    super(MeterRouter.BASE_PATH, axios);
  }
}

export const meterApi = new MeterApi(axiosInstance);
